/**
 * Shapes the edit-diagnosis drawer values into the payload sent when saving a study diagnosis. Defaults the primary and second diagnoses to null when nullish and trims the physician's note and the patient medications.
 *
 * @param payload - Raw drawer form values.
 * @returns Payload wrapping the normalized diagnosis fields.
 */
const convertPayload = (payload: any) => ({
  diagnosis: {
    primary: payload.primary ?? null,
    second: payload.second ?? null,
    physiciansNote: payload.physiciansNote?.trim(),
    patientMedications: payload.patientMedications?.trim(),
  },
});

export { convertPayload };
